import React from "react";
import { formatKioskDfaStatus, formatKioskMetric } from "../hooks/kioskDashboard.helpers";

const KioskMonitoringTable = ({
  rows = [],
  onReport,
  page = 1,
  pageSize = 25,
  total = rows.length,
  onPageChange,
}) => {
  const currentPage = Math.max(1, Number(page) || 1);
  const currentPageSize = Math.max(1, Number(pageSize) || 25);
  const totalRows = Math.max(0, Number(total) || 0);
  const pageCount = Math.max(1, Math.ceil(totalRows / currentPageSize));

  return (
  <section className="bg-white border border-slate-200/80 rounded-2xl p-5 shadow-sm" aria-labelledby="kiosk-monitoring-title">
    <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
      <div>
        <h2 id="kiosk-monitoring-title" className="text-lg font-bold text-[#1D1F3F] font-display">Resumen por usuario</h2>
        <p className="text-xs text-slate-500 mt-1">Última medición completada y métricas clínicas aprobadas</p>
      </div>
      <span className="text-xs font-semibold text-slate-400">{totalRows} usuarios</span>
    </div>

    <div className="overflow-x-auto -mx-5 px-5">
      <table className="w-full min-w-[900px] border-collapse">
        <thead>
          <tr className="border-b border-slate-200/70">
            {[
              "Usuario", "Mediciones", "HRV (RMSSD)", "SDNN", "pNN50", "Puntaje cardiovascular", "DFA Alpha-1", "Estado DFA", "Última medición", "",
            ].map(label => (
              <th key={label || "acciones"} className="pb-3 pr-4 text-left text-[10px] font-bold uppercase tracking-wider text-slate-400 font-display">
                {label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.length === 0 ? (
            <tr>
              <td colSpan="10" className="py-10 text-center text-sm font-medium text-slate-500">
                No hay usuarios con mediciones para este periodo.
              </td>
            </tr>
          ) : rows.map(row => {
            const latest = row.ultimaMedicion;
            const metrics = latest && latest.metricasClinicas;
            return (
              <tr key={row.usuarioId} className="text-sm text-slate-700">
                <td className="py-3 pr-4 font-semibold text-[#1D1F3F]">{row.nombre || `Usuario ${row.usuarioId}`}</td>
                <td className="py-3 pr-4">{row.medicionesTotal}</td>
                <td className="py-3 pr-4">{formatKioskMetric(metrics && metrics.rmssd)}</td>
                <td className="py-3 pr-4">{formatKioskMetric(metrics && metrics.sdnn)}</td>
                <td className="py-3 pr-4">{formatKioskMetric(metrics && metrics.pnn50)}</td>
                <td className="py-3 pr-4">{formatKioskMetric(metrics && metrics.cardiovascularScore)}</td>
                <td className="py-3 pr-4">{formatKioskMetric(metrics && metrics.alpha1)}</td>
                <td className="py-3 pr-4 whitespace-nowrap">
                  {formatKioskDfaStatus(metrics && metrics.fatigueStatus)}
                </td>
                <td className="py-3 pr-4 whitespace-nowrap">{latest ? String(latest.timestampUtc).slice(0, 16).replace("T", " ") : "N/D"}</td>
                <td className="py-3 text-right">
                  {latest && latest.reportable !== false && (
                    <button
                      type="button"
                      onClick={() => onReport && onReport(latest.sessionId)}
                      aria-label={`Ver reporte de ${row.nombre || `usuario ${row.usuarioId}`}`}
                      className="text-xs font-bold text-[#0075AC] hover:text-[#1D1F3F] underline underline-offset-2"
                    >
                      Ver reporte
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
    {pageCount > 1 && (
      <div className="mt-4 flex items-center justify-between gap-3 text-xs text-slate-500">
        <span>Mostrando {rows.length ? ((currentPage - 1) * currentPageSize) + 1 : 0}–{Math.min(currentPage * currentPageSize, totalRows)} de {totalRows}</span>
        <div className="flex items-center gap-2">
          <button
            type="button"
            aria-label="Página anterior"
            disabled={currentPage <= 1}
            onClick={() => onPageChange && onPageChange(currentPage - 1)}
            className="rounded-lg border border-slate-200 px-2.5 py-1.5 font-semibold disabled:cursor-not-allowed disabled:opacity-40"
          >
            Anterior
          </button>
          <span className="font-semibold">Página {currentPage} de {pageCount}</span>
          <button
            type="button"
            aria-label="Página siguiente"
            disabled={currentPage >= pageCount}
            onClick={() => onPageChange && onPageChange(currentPage + 1)}
            className="rounded-lg border border-slate-200 px-2.5 py-1.5 font-semibold disabled:cursor-not-allowed disabled:opacity-40"
          >
            Siguiente
          </button>
        </div>
      </div>
    )}
  </section>
  );
};

export default KioskMonitoringTable;
